import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ArrowUp from '@material-ui/icons/ArrowUpward';

import { scrollTo } from 'helpers/utils';
import { getSelector } from 'redux/selectors';
import { isMobile } from 'helpers/detect-mobile';

const styles = () => ({
  root: {
    color: '#ff5722',
    fontSize: 36,
  },
});

export class ScrollToTop extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    id: PropTypes.string,
    invisibleHeight: PropTypes.number,
    scrollTop: PropTypes.number,
  };

  static defaultProps = {
    id: null,
    invisibleHeight: 500,
    scrollTop: 10,
  };

  state = {
    isScrolledToTable: false,
  };

  setScrolledToTable = () => {
    this.setState({ isScrolledToTable: !this.state.isScrolledToTable });
  }

  render() {
    const {
      classes,
      id,
      invisibleHeight,
      scrollTop,
    } = this.props;
    const { isScrolledToTable } = this.state;
    if (scrollTop < invisibleHeight) return null;
    return (
      <IconButton
        className="scroll-to-top"
        onClick={() => {
          if (id && id === 'order-table') {
            if (!isScrolledToTable) {
              if (isMobile) {
                scrollTo('mobile-order-table-for-scroll');
              } else {
                scrollTo('order-table-for-scroll');
              }
            } else {
              scrollTo(undefined, { isAnimateScroll: true });
            }
          } else {
            scrollTo(undefined, { isAnimateScroll: true });
          }
          this.setScrolledToTable();
        }}
      >
        <ArrowUp classes={{ root: classes.root }} />
      </IconButton>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  scrollTop: getSelector('ui', 'scrollTop')(state),
});

const wrappedScrollToTop = connect(mapStateToProps)(withStyles(styles)(ScrollToTop));
wrappedScrollToTop.displayName = 'ScrollToTop';

export default wrappedScrollToTop;
